import { render, staticRenderFns } from "./BaseFormViewItemInput.vue?vue&type=template&id=06247f5d&scoped=true"
import script from "./BaseFormViewItemInput.vue?vue&type=script&lang=js"
export * from "./BaseFormViewItemInput.vue?vue&type=script&lang=js"
import style0 from "./BaseFormViewItemInput.vue?vue&type=style&index=0&id=06247f5d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06247f5d",
  null
  
)

export default component.exports